export const INIT_APP = 'core/lifecycle/INIT_APP'

export const initApp = params => ({
  type: INIT_APP,
  params
})
